/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ico-toilet': {
    width: 16,
    height: 16,
    viewBox: '0 0 300 300',
    data: '<path pid="0" d="M222 188h-.73a8 8 0 00-5.27-2h-14v-22a6 6 0 00-6-6h-14v-6h8v-4h-8a4 4 0 00-4 4v6h-26v-18a8 8 0 0116 0h4a12 12 0 00-24 0v18h-26v-6a4 4 0 00-4-4h-8v4h8v6h-14a6 6 0 00-6 6v22H84a8 8 0 00-8 8v52a8 8 0 008 8h132a8 8 0 005.27-2h.73v-.73a8 8 0 002-5.27v-52a8 8 0 00-2-5.27zm-70 24h64v16h-64zm0-18h64v14h-64zm64 38v14h-64v-14zm-114-68a2 2 0 012-2h92a2 2 0 012 2v22h-96zm-18 30h64v52H84zM212 46H88a12 12 0 00-12 12v44a12 12 0 0012 12h124a12 12 0 0012-12V58a12 12 0 00-12-12zm4 56a4 4 0 01-4 4H88a4 4 0 01-4-4V58a4 4 0 014-4h124a4 4 0 014 4z"/><path pid="1" d="M138 199h4v21h-4zM88.584 68.582l9.998-9.999 2.829 2.829-9.999 9.998zM88.587 88.58l30.003-30.002 2.828 2.828L91.416 91.41z"/>'
  }
})
